<mat-tab-group [selectedIndex]="selectedTabIndex" (selectedTabChange)="selectedIndexChange($event)">
  <mat-tab label="{{ 'DETAIL' | translate }}">
    <ng-template matTabContent>
      <wim-project-detail></wim-project-detail>
    </ng-template>
  </mat-tab>

  <mat-tab label="{{ 'PROJECT.CONSUMPTION' | translate }}">
    <ng-template matTabContent>
      <wim-project-detail-consumption></wim-project-detail-consumption>
    </ng-template>
  </mat-tab>
</mat-tab-group>
